import React, { useEffect, useState } from "react";
import MonthlyCommonDashboard from "../MonthlyCommonDashboard/MonthlyCommonDashboard";
import { GetSuretyRegisterReportExportToExcel } from "../../../../Helpers/APIEndPoints/EndPoints";

const SuretyRegister = () => {
  return (
    <>
      <MonthlyCommonDashboard
        PageName="SuretyRegister"
        ExportToExcelUrl={GetSuretyRegisterReportExportToExcel}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default SuretyRegister;
